import * as React from 'react';
import { TextField } from '@material-ui/core';
const defaultOptions = { numberType: 'NUMBER' };
export default (options = defaultOptions) => (props) => {
    return (React.createElement(TextField, { multiline: options.multiline, fullWidth: true, inputProps: {
            maxLength: options.maxLength,
        }, label: props.propertyOptions.displayName, value: props.value || '', onChange: (e) => {
            let val = 0;
            if (options.numberType === 'FLOAT') {
                val = parseFloat(e.target.value);
            }
            if (options.numberType === 'NUMBER') {
                val = Number(e.target.value);
            }
            if (options.numberType === 'INT') {
                val = parseInt(e.target.value);
            }
            return props.setValue(val);
        }, type: "number" }));
};
